import { ConfigFileSection } from '@/types';
import { ConfigFileManagedButton } from '@/components/HOCs/ConfigFileManagedMessage';
import Form from 'antd/lib/form';
import Space from 'antd/lib/space';
import { ArrowRightOutlined } from '@ant-design/icons';
import { isEqual, set } from 'lodash';
import * as React from 'react';
import { FormFieldData, renderFormFields } from '../../../../helpers/formHelpers';
import { SetupViewProps } from '../../../../typescriptHelpers';
import { Integration } from '../../../../types';
import { tryUpdateIntegrationRequest, UpdateIntegrationRequest } from '../../../../actions/integrations';
import { useDispatch, useSelector } from 'react-redux';
import { getIsLoading } from '../../../../helpers';
import { integrationUpdatableForIntegrationType } from '../../../../helpers/integrationHelpers';
import { RootState } from '../../../../reducers/reducers';
import { IntegrationUpdatable } from '../../../../actions/updatable';
import { FormInstance } from 'antd/lib/form';

export interface WorkflowModuleProps extends SetupViewProps {
    form: FormInstance<any>;
    fields: FormFieldData[];
    integration: Integration;
    integrationSetupType: IntegrationUpdatable;
}

export const WorkflowModule: React.FC<WorkflowModuleProps> = ({
    appId,
    orgId,
    onChange,
    form,
    fields,
    integration,
    integrationSetupType,
}) => {
    const dispatch = useDispatch();

    // BE-defined fields can have nested names, so values are set by path to match getFieldsValue
    const initialValues = fields.reduce((acc, field) => set(acc, field.name, field.initialValue), {});

    const checkIfHasUnsavedChanges = () => {
        const formValues = form.getFieldsValue();
        return !isEqual(formValues, initialValues);
    };

    const updateIntegrationIsLoading = useSelector((state: RootState) =>
        getIsLoading(integrationSetupType, state, integration?.installationId),
    );

    const updateIntegration = (values) => {
        const type = integrationUpdatableForIntegrationType(integration.id);

        const updateRequest: UpdateIntegrationRequest = {
            orgId,
            appId,
            integrationId: integration.installationId,
            // Setting fields already use the save payload's shape
            data: values,
            isPartialUpdate: true,
        };

        dispatch(tryUpdateIntegrationRequest(type, updateRequest));
    };

    return (
        <Form
            form={form}
            onFinish={updateIntegration}
            initialValues={initialValues}
            onFieldsChange={() => {
                onChange(checkIfHasUnsavedChanges());
            }}
        >
            <Space direction="vertical" style={{ width: '100%' }} size={20}>
                {renderFormFields(fields)}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                    }}
                >
                    <Form.Item style={{ marginBottom: 0 }} shouldUpdate>
                        {() => (
                            <ConfigFileManagedButton
                                configFileSection={ConfigFileSection.Integrations}
                                loading={updateIntegrationIsLoading}
                                disabled={!checkIfHasUnsavedChanges()}
                                type="primary"
                                htmlType="submit"
                                icon={<ArrowRightOutlined />}
                            >
                                Save
                            </ConfigFileManagedButton>
                        )}
                    </Form.Item>
                </div>
            </Space>
        </Form>
    );
};
